
import { buildGroupHierarchy, findGroupCode, formatCurrency, getGroupCode, statusTranslations } from "../../../../Utils/Utils";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import CurrencyAmountInput from "../../../UIElements/Inputs/CurrencyAmountInput";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import HistoryElement from "../../../UIElements/HistoryElement";
import ProductsAndServicesPickerSidebar from "../../../UIElements/ProductsAndServicesPickerSidebar";
import TextInput from "../../../UIElements/Inputs/TextInput";
import useApi from "../../../../Utils/BackendClient";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { TreeSelect } from "primereact/treeselect";

import commonStyle from "../../CommonStyles.module.css";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const ServiceCreation = () => {

    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef(null);

    const { createService, fetchServicesExtended, fetchServiceDetails, fetchServiceGroupDetails, fetchServiceHistory, updateService } = useApi();

    const [customfields, setCustomFields] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [service, setService] = useState({
        name: '',
        service_group: null,
        service_article: '',
        price: '',
        currency: "UAH",
        notes: '',
        is_active: true,
        service_fields_values: [],
        attached_products: []
    });
    const [serviceHistory, setServiceHistory] = useState([]);
    const [sortedGroups, setSortedGroups] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [visible, setVisible] = useState(false);

    useEffect(() => {

        const getGroupsExtended = async () => {

            const response = await fetchServicesExtended();

            if (response.status === 200) {

                const groups = buildGroupHierarchy(response.data);
                setSortedGroups(groups);

                if (location.state !== null) {

                    setIsEdit(true);

                    const fetchData = async () => {

                        const response = await fetchServiceDetails(location.state.id);

                        if (response.status === 200) {
                            response.data.service_group = findGroupCode(groups, response.data.service_group);

                            let fields = [];
                            let serviceFields = {};

                            response.data.service_fields_values.forEach(element => {
                                const field = {
                                    id: element.service_group_field,
                                    field_id: element.id,
                                    name: element.name,
                                    field_type: element.field_type
                                };

                                fields = [...fields, field];
                                serviceFields[element.service_group_field] = element.value;
                            });

                            response.data.service_fields_values = serviceFields;

                            setService(response.data);
                            setCustomFields(fields);
                        }
                    };

                    fetchData();
                }
            }
        }

        getGroupsExtended();

    }, [location.state, fetchServiceDetails, fetchServicesExtended]);

    const DropdownChangeHandler = async (e) => {

        let service_group_code = e.value;

        let serviceGroupId = service_group_code;

        if (service_group_code !== null && service_group_code !== undefined) {
            if (service_group_code.toString().includes('-')) {
                var keys = service_group_code.split('-');
                serviceGroupId = keys[(keys.length - 1)];
            }
        }
        else {
            service_group_code = null;
        }

        formik.setFieldValue('service_group', service_group_code);

        if (serviceGroupId != null) {

            const fetchData = async () => {

                const response = await fetchServiceGroupDetails(serviceGroupId);

                if (response.status === 200) {
                    const fields = response.data.fields;

                    setCustomFields(fields);

                    console.log(fields);
                    console.log(customfields);

                    const transformedObject = fields.reduce((acc, field) => {
                        acc[field.id] = "";
                        return acc;
                    }, {});

                    formik.setFieldValue('service_fields_values', transformedObject);
                }
            }

            fetchData();
        }
        else {
            setCustomFields(null);
        }
    };

    const formik = useFormik({
        initialValues: service,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.name === null || values.name === "") {
                errors.name = "Назва послуги не повинна бути пустою";
            }

            if (values.service_group === null || values.service_group === undefined) {
                errors.service_group = "Виберіть групу послуг";
            }

            if (values.price === null || values.price === "") {
                errors.price = "Введіть ціну послуги";
            }

            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = {
                ...values,
                service_group: getGroupCode(values.service_group),
                service_fields_values: buildServiceFields(values, isEdit, customfields)
            };

            const response = !isEdit ? await createService(payload) : await updateService(values.id, payload);

            setSubmitLoading(false);

            const successStatus = location.state ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = !isEdit ? { severity: "success", summary: "Успіх створення", detail: "Сервіс " + values.name + " успішно створено", life: 3000 } :
                    { severity: "success", summary: "Успіх редагування", detail: "Сервіс " + values.name + " успішно відредаговано", life: 3000 }

                navigate("/services", { state: { toast: toastMessage, servicesPageState: location.state?.pageState } });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    const buildServiceFields = (values, isEdit, customfields) =>
        Object.entries(values.service_fields_values).map(([key, value]) => {
            const field = {
                service_group_field: key,
                value
            };

            if (isEdit) {
                const element = customfields.find(e => e.id === Number(key));
                if (element) {
                    field.id = element.field_id;
                }
            }

            return field;
        });

    const getServiceHistory = async (id, state) => {

        const response = await fetchServiceHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setServiceHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getServiceHistory(formik.values.id, event);

        setHistoryLazyState(event);
    }

    const ProductConnectionHandler = () => {
        setVisible(true);
    }

    const ConnectProductToService = (product) => {
        product.product_id = product.id;
        const connectedProducts = [...formik.values.attached_products, product];

        formik.setFieldValue("attached_products", connectedProducts);

        setVisible(false);
    }

    const DeleteConnectedProduct = (id) => {
        const newConnectedProducts = formik.values.attached_products.filter(product => product.product_id !== id);

        formik.setFieldValue("attached_products", newConnectedProducts);
    }

    const items = [
        {
            label: 'Налаштуванна полів',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        {
            label: 'Прикріплені товари',
            icon: 'pi pi-hammer',
            command: () => {
                setTabShowed(1);
            },
        },
        {
            label: 'Опис',
            icon: 'pi pi-comment',
            command: () => {
                setTabShowed(2);
            },
        },
        ...(formik.values?.id
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(3);
                        getServiceHistory(formik.values?.id, historyLazyState);
                    },
                },
            ]
            : []),
    ];

    const confirmLeave = (event) => {

        if (formik.values !== service) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => {
                    navigate("/services", { state: { servicesPageState: location.state?.pageState } });
                }
            });

        }
        else {
            navigate("/services", { state: { servicesPageState: location.state?.pageState } });
        }
    }

    const toolbarLeftData = () => {
        let name = "Створення послуги";

        if (isEdit) {
            name = "Редагування послуги " + formik.values.name;
        }

        return !isMobile ? <h3>{name}</h3> : null;
    }

    const connectedProductsToolbarEnd = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label={`${isMobile ? "" : "+Прикріпити товар"}`} icon={`${isMobile ? "pi pi-plus" : null}`} severity="success" className={commonStyle.addButton} type="button" onClick={ProductConnectionHandler} />
            </div>
        </>);
    }

    const actionBodyTemplate = (rowData) => {
        return (<Button
            icon="pi pi-trash"
            className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
            tooltip="Видалити товар"
            tooltipOptions={{ showOnDisabled: true, position: "top" }}
            type="button"
            onClick={() => DeleteConnectedProduct(rowData.product_id)}
        />)
    }

    return (<>
        <form onSubmit={formik.handleSubmit}>
            <Toast ref={toast} />
            <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
            <ConfirmDialog group="headless" />
            <div className="grid nested-grid">
                <div className={`${commonStyle.leftMenu} col-3`}>
                    <div className={commonStyle.formInput}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <TreeSelect
                                    name="service_group"
                                    value={formik.values.service_group}
                                    onChange={DropdownChangeHandler}
                                    options={sortedGroups}
                                    showClear
                                    className={formik.errors.service_group && formik.touched.service_group ? 'p-invalid w-full' : 'w-full'} />
                                <label>Назва групи{<span className={commonStyle.requiredAsterisk}>*</span>}</label>
                            </FloatLabel>
                            {formik.errors.service_group && formik.touched.service_group && (<small className={commonStyle.errorSmall}>{formik.errors.service_group}</small>)}
                        </div>
                    </div>
                    <TextInput formik={formik} paramName="name" label="Назва послуги" mandatory />
                    <TextInput formik={formik} paramName="service_article" label="Артикул" />
                    <CurrencyAmountInput
                        amount={formik.values.price}
                        currency={formik.values.currency}
                        onAmountChange={(val) => { formik.setFieldValue('price', val) }}
                        onCurrencyChange={(val) => { formik.setFieldValue('currency', val) }}
                        errors={formik.errors.price}
                        touched={formik.touched.price}
                        mandatory
                    />
                    <DropdownInput
                        formik={formik}
                        paramName="is_active"
                        context={statusTranslations}
                        onChange={(val) => formik.setFieldValue('is_active', val)}
                    />
                </div>
                <div className="col-9">
                    <TabMenu model={items} />
                    {tabShowed === 0 && <div className="grid">
                        {customfields != null && (customfields.map((field) => (
                            <div className="col-4" key={field.id}>
                                <div className={`${commonStyle.inputfields} flex-column p-inputgroup`}>
                                    <FloatLabel>
                                        <InputText
                                            name={`service_fields_values.${field.id}`}
                                            value={formik.values.service_fields_values[field.id] || ""}
                                            onChange={(e) => { formik.setFieldValue(`service_fields_values.${field.id}`, e.target.value) }}
                                        />
                                        <label>{field.name}</label>
                                    </FloatLabel>
                                </div>
                            </div>
                        )))}
                    </div>}
                    {tabShowed === 1 && <>
                        <Toolbar className="mb-4" end={connectedProductsToolbarEnd} />
                        <DataTable value={formik.values.attached_products} emptyMessage="Немає прикріплених товарів">
                            <Column field="product_name" header="Товар" />
                            <Column field="price" header="Ціна" body={(rowData) => formatCurrency(rowData.price, rowData.currency)} />
                            <Column field="action" body={actionBodyTemplate} />
                        </DataTable>
                    </>}
                    {tabShowed === 2 && <InputTextarea className={commonStyle.fullWidth} value={formik.values.notes} onChange={(e) => { formik.setFieldValue('notes', e.target.value) }} rows={10} />}
                    {tabShowed === 3 && <HistoryElement data={serviceHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={false} />}
                </div>
                <ProductsAndServicesPickerSidebar sbVisible={visible} onHide={() => setVisible(false)} type="products" onSelect={(product) => ConnectProductToService(product)} />
            </div>
        </form>
    </>
    );
}

export default ServiceCreation;